angular.module('MW.ContactManager.FilterFactory', [
    'MW.Framework.MEDAppModelBuilder',
    'MW.Framework.SelectAccordionItem',
    'MW.Framework.TranslationService'
    ])
.factory('ContactManagerFilterFactory', ['SelectAccordionItem', 'translationService', 'MEDAppModelBuilder', function(SelectAccordionItem, translationService, MEDAppModelBuilder){
    'use strict';

    function FilterFactory(filterList) {
        this.options = [];

        if(this[filterList.id]){
            this[filterList.id](filterList);
        }else{
            this.buildOptionItems(filterList.data);
        }

        return this.filter;
    }

    FilterFactory.prototype.location = function location(list){
        list.data.forEach(function loopItems(item) {
            this.options.push(new SelectAccordionItem({
                id: item.name,
                name: item.name,
                code: item.code
            }));
        }, this);
    };

    FilterFactory.prototype.regions = function regions(list){
        list.data.forEach(function loopItems(item){
            this.options.push(new SelectAccordionItem({
                id: item.name,
                name: item.name,
                code: item.name
            }));
        }, this);
    };

    FilterFactory.prototype.subregions = function subRegions(list){
        list.data.forEach(function loopItems(item){
            this.options.push(new SelectAccordionItem({
                id: item,
                name: item
            }));
        }, this);
    };

    FilterFactory.prototype.buildOptionItems = function buildOptionItems(data){
        if(data && Array.isArray(data)) {
            data.forEach(function buildLoop(item){
                this.options.push(new SelectAccordionItem({
                    id: item.name,
                    name: item.name
                }));
            }, this);
        }
    };

    FilterFactory.build = function build(attributes){
        attributes = attributes || {};

        return MEDAppModelBuilder.build(attributes, FilterFactory);
    };

    return FilterFactory;
}]);
